import axios from "axios";
import * as ROUTES from "../../../../constants/routes";
import Helpers from "../../../Helpers";

export default class CategoryListFunction {
  constructor() {
    this.helpers = new Helpers();
  }

  doDeleteCategory = (categoryId, categoryCode) => {
    const token = this.helpers.getCookie("token");
    return new Promise((resolve, reject) => {
      axios
        .post(
          ROUTES.FUNCTIONAL_BASE_URL + "funds-funds/deleteCategory",
          JSON.stringify({
            categoryUid: categoryId,
            categoryCode: categoryCode,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          this.helpers.handleError(err);
          reject(err);
        });
    });
  };
}
